import { SxProps, Theme } from "@mui/material";

export const outerContainerStyles: SxProps<Theme> = (theme: Theme) => ({
  borderBottomWidth: "1px",
  borderBottomStyle: "solid",
  borderBottomColor: theme.palette.recordingsModal.separator,
  padding: "10px 0",
});

export const recordingContainerStyles: SxProps = {
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  gap: "1rem",
};

export const recordingHeaderStyles: SxProps = {
  alignSelf: "stretch",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  alignContent: "flex-start",
  alignItems: "baseline",
  gap: "10px",
  flexWrap: "wrap-reverse",
};

export const replayModeSelectStyles: SxProps = {
  minWidth: "10rem",
  fontSize: "14px",
  textTransform: "uppercase",
  borderRadius: "12px",
  "& .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
  "&:hover .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
    borderColor: "#06B6D4",
  },
  "& .MuiSvgIcon-root": {
    color: "#06B6D4",
  },
  color: "#06B6D4",
};

export const scoreStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "14px",
  fontWeight: "normal",
  color:
    theme.palette.mode === "dark"
      ? theme.palette.common.white
      : theme.palette.modalColors.colorLable,
  flexGrow: 1,
});

export const shortTranscriptContainerStyles: SxProps = {
  width: "100%",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  gap: "5px",
  paddingX: "10px",
};

export const menuContainerStyles: SxProps = {
  width: "100%",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "flex-start",
  columnGap: "8px",
  rowGap: "5px",
  flexWrap: "wrap",
  marginBottom: "10px",
};

export const moreButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  margin: "0 5px",
  padding: 0,
  border: "none",
  textTransform: "none",
  backgroundColor: theme.palette.recordingsModal.button.default,
  color: "white",
  borderRadius: "10px",
  boxShadow: "none",

  "&:hover": {
    boxShadow: "none",
    background: theme.palette.recordingsModal.button.hover,
  },
});

export const highlightsButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  borderRadius: "0.75rem",
  display: "flex",
  flexDirection: "row",
  gap: "4px",
  padding: "6px 12px",
  fontSize: "12px",
  minHeight: "32px",
  backgroundColor: theme.palette.recordingsModal.button.default,
  boxShadow: "none",

  "&:hover": {
    boxShadow: "none",
    background: theme.palette.recordingsModal.button.hover,
  },
});

export const coachingModelButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  borderRadius: "0.75rem",
  display: "flex",
  flexDirection: "row",
  gap: "4px",
  padding: "6px 12px",
  fontSize: "12px",
  minHeight: "32px",
  backgroundColor: theme.palette.recordingsModal.button.default,
  boxShadow: "none",

  "&:hover": {
    boxShadow: "none",
    background: theme.palette.recordingsModal.button.hover,
  },
});

export const downloadButtonStyles: SxProps<Theme> = (theme: Theme) => ({
  borderRadius: "0.75rem",
  display: "flex",
  flexDirection: "row",
  gap: "4px",
  padding: "6px 12px",
  fontSize: "12px",
  minHeight: "32px",
  backgroundColor: "#6FCF97",
  boxShadow: "none",

  "&:hover": {
    boxShadow: "none",
    background: "#6FCF97C0",
  },
});

export const reportStyles: SxProps<Theme> = (theme: Theme) => ({
  fontSize: "14px",
  fontWeight: "normal",
  color:
    theme.palette.mode === "dark"
      ? theme.palette.common.white
      : theme.palette.modalColors.colorLable,
  padding: "0 10px",
});
